"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Target, TrendingUp, Shield } from "lucide-react";
export default function PourquoiNousChoisir() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const benefits = [{
    icon: Target,
    title: "Expertise ciblée",
    description: "Stratégies SEO et IA sur mesure pour maximiser votre visibilité locale et générer des leads qualifiés."
  }, {
    icon: TrendingUp,
    title: "Résultats mesurables",
    description: "Suivi transparent de vos performances avec des rapports détaillés et des objectifs clairs à chaque étape."
  }, {
    icon: Shield,
    title: "Tarifs transparents",
    description: "Pas de surprise : budgets maîtrisés, engagements clairs et accès complet à vos campagnes en temps réel."
  }];
  return <section id="pourquoi-nous-choisir" ref={sectionRef} className="py-16 px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-12 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
            Pourquoi nous choisir
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">Poire Com vous accompagne avec expertise, transparence et résultats concrets pour développer votre présence digitale.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div key={i} data-index={i} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <Card className="h-full hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group">
                  <CardContent className="flex flex-col items-center text-center pt-8 pb-8">
                    <div className="mb-6 p-4 rounded-lg bg-primary-light inline-flex items-center justify-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-[1.02] group-hover:shadow-[0_0_20px_hsl(45_95%_55%/0.3)]">
                      <Icon className="w-10 h-10 text-primary-dark" strokeWidth={2} />
                    </div>
                    <h3 className="text-xl font-display font-semibold text-foreground mb-3">
                      {benefit.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {benefit.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}